const tryClearModelsFromLocalStorage = () => {
  try {
    for (const keyName in localStorage) {
      const keyNameArr = keyName.split(".")
      const [key] = keyNameArr
      const isModel = key === "tsis" || key === "ets"

      if (isModel) {
        localStorage.removeItem(keyName)
      }
    }
  } catch (err) {
    console.log("tryClearModelsFromLocalStorage failed:", err)
  }
}

const logout = () => {
  return fetch(`/graphql`, {
    credentials: "same-origin",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query: `
        mutation LOGOUT {
          logout {
            id
            response {
              payload
              message
            }
          }
        }`,
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      tryClearModelsFromLocalStorage()

      return res
    })
}

const login = (email, password) => {
  return fetch(`/graphql`, {
    credentials: "same-origin",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query: `
        mutation LOGIN(
          $email: String!,
          $password: String!
        ) {
          login(email: $email, password: $password) {
            id
            name
            userId
            email
            roles
            loginsCount
            response {
              payload
              message
            }
          }
        }`,
      variables: { email, password },
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      const { login } = res.data
      if (login.response.payload === "success") {
        window.analytics.identify(login.email, {
          id: login.userId,
          name: login.name,
          roles: login.roles,
          email: login.email,
        })
      }
      tryClearModelsFromLocalStorage()
      return res
    })
}

export { logout, login }
